import {
    useState,
    useEffect,
    useRef,
    useMemo
} from 'react';
import {
    Container,
    Content,
    AddContact,
    Contacts
} from './styled';
import {
    Avatar,
    Search,
    Skeleton,
    ContactProfile,
    ContactNew
} from '../../components';
import { getFullClients } from '../../service/serviceChat/clientsService';
import { IoMdPersonAdd } from "react-icons/io";

export function ContactsList(props) {

    const listRef = useRef(null);
    const [textSearch, setTextSearch] = useState('');
    const [contacts, setContacts] = useState([]);
    const [openNewChat, setOpenNewChat] = useState(false);
    const [contactSelected, setContactSelected] = useState(null);
    const [loading, setLoading] = useState(false);
    const [loadingContacts, setLoadingContacts] = useState(false);
    const [displayedPeople, setDisplayedPeople] = useState(50);

    const searchContacts = async () => {
        setLoading(true);
        setLoadingContacts(true);
        setContacts(await getFullClients());
        setLoading(false);
        setLoadingContacts(false);
    };
    useEffect(() => {
        searchContacts();
    }, []);

    const handleScroll = () => {
        const element = listRef.current;
        if (element.scrollTop + element.clientHeight + 50 >= element.scrollHeight) {
            setDisplayedPeople(prevCount => prevCount + 50);
        }
    };
    useEffect(() => {
        const element = listRef.current;
        element.addEventListener('scroll', handleScroll);
        return () => element?.removeEventListener('scroll', handleScroll);
    }, []);

    const onFilterContacts = (contact) => {
        const textSearchLower = textSearch?.toLowerCase();
        if (textSearch.length < 3) return contact
        return contact?.name?.toLowerCase()?.includes(textSearchLower)
            || contact?.number_client?.toLowerCase()?.includes(textSearchLower);
    };
    const visibleData = contacts?.filter(onFilterContacts).slice(
        0,
        displayedPeople
    );
    const myStateElements = useMemo(() => {
        return visibleData?.map((contact) => {
            return (
                <li className='card--Contact'
                    key={contact.id}
                    onClick={() =>
                        setContactSelected(contact)
                    }
                >
                    <span className='avatar--'>
                        <Avatar
                            name={contact?.name}
                            width={'3.5rem'}
                            height={'3.5rem'}
                            fontSize={'1.5rem'}
                        />
                    </span>
                    <span className='info--'>
                        <span className='name'>
                            <span className='name--overflow'>
                                {contact?.name}
                            </span>
                        </span>
                        <span className='description'>
                            {contact?.number_client}
                        </span>
                    </span>
                </li>
            );
        })
    }, [visibleData]);

    const SkeletonRender = ({ count }) => {
        const skeletonArray = [];
        for (let i = 0; i < count; i++) {
            skeletonArray.push(<Skeleton type='contact' key={i} />);
        }
        return (
            <div>
                {skeletonArray}
            </div>
        );
    };

    return (
        <>
            <Container loading={loading ? 1 : 0}>
                <Content>
                    <Search
                        className='search'
                        value={textSearch}
                        onChange={
                            (e) => setTextSearch(e.target.value)
                        }
                    />
                    <AddContact onClick={() => setOpenNewChat(true)}>
                        <span>
                            <IoMdPersonAdd
                                fontSize={`1.5rem`}
                            />
                        </span>
                        <div>
                            {`Novo Contato`}
                        </div>
                    </AddContact>
                    <Contacts ref={listRef}>
                        {loadingContacts
                            ? <SkeletonRender count={15} />
                            : <>{myStateElements}</>
                        }
                    </Contacts>
                </Content>
            </Container >
            {contactSelected &&
                (
                    <ContactProfile
                        contact={contactSelected}
                        onBack={() => setContactSelected(null)}
                        onLoad={() => searchContacts()}
                    />
                )
            }
            {openNewChat &&
                (
                    <ContactNew
                        onBack={() => {
                            setOpenNewChat(false);
                        }}
                        onLoadContacts={() => searchContacts()}
                    />
                )
            }
        </>
    );
}